import { ParseResult, Schema } from "@effect/schema";
import { ChainKey } from "./chain";
import { Address } from "./address";
import { Effect, pipe, String, Array } from "effect";

export const SKELETON_TOKEN_SYMBOL = "ABC";
export const SKELETON_TOKEN_NAME = "ABC token";

export type TokenUid = typeof TokenUid.Type;
export type TokenUidEncoded = typeof TokenUid.Encoded;

export const TokenUid = Schema.Struct({
  chainKey: ChainKey,
  tokenAddress: Address,
}).annotations({ identifier: "TokenUid" });

export type TokenUidFromString = typeof TokenUidFromString.Type;
export type TokenUidFromStringEncoded = typeof TokenUidFromString.Encoded;

export const TokenUidFromString = Schema.transformOrFail(
  Schema.String,
  TokenUid,
  {
    decode: (s, _, ast) =>
      pipe(
        Effect.gen(function* () {
          const tuple = pipe(s, String.split("-"));

          const chainKey = yield* pipe(
            tuple,
            Array.get(0),
            Effect.andThen(Schema.validate(ChainKey))
          );

          const tokenAddress = yield* pipe(
            tuple,
            Array.get(1),
            Effect.andThen(Schema.validate(Address))
          );

          return { chainKey, tokenAddress };
        }),
        Effect.mapBoth({
          onFailure: (error) => new ParseResult.Type(ast, s, error.message),
          onSuccess: (tokenUid) => tokenUid,
        })
      ),
    encode: ({ chainKey, tokenAddress }) => {
      const encoded = `${chainKey}-${tokenAddress}`;

      return Effect.succeed(encoded);
    },
  }
);
